import { MATA_MATA_SECTION } from "@app/pages/UGC/UGCLandingPage/UGCLandingPage";
import { GADataProps } from "@elements/GAData/GAData";
import {
  getAuthorsName,
  getContentCat,
  getTagsName,
} from "@elements/GAData/GADataHelper";
import { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import { getArticleJSONLD } from "@helper/jsonLDHelper";
import { dateFormatWithTz, formatDate } from "@helper/useDateFormat";
import { getFirstParagraph } from "@pages/Article/ArticleMetaData";
import { ProcessedArticleData } from "@transformer/useOSResponse";
import { RawImageField } from "@typings/Opensearch";
import { PageMetaDataValues } from "@typings/PageMetaData";

type UGCArticleMetaDataProps = {
  article: ProcessedArticleData;
  pageNumber: number;
  gsChannels: string[];
};

export default function UGCArticleMetaData({
  article,
  pageNumber,
  gsChannels,
}: UGCArticleMetaDataProps): PageMetaDataValues {
  const keywords = getTagsName(article.tags || []);
  const image = {
    url: article.imageField?.url,
    width: 480,
    height: 270,
  } as RawImageField;
  const ogImage = {
    url: article.ogImageUrl || article.imageField?.url,
    width: 480,
    height: 270,
  } as RawImageField;

  const metaTitle =
    article.seoFields?.metaTitle && article.seoFields.metaTitle !== ""
      ? article.seoFields.metaTitle
      : `${article.title}, Berita - Beritaharian.sg`;
  const metaDescription =
    article.seoFields?.metaDescription &&
    article.seoFields.metaDescription !== ""
      ? article.seoFields.metaDescription
      : `Berita - ${getFirstParagraph(article.articleBody)} Baca lebih lanjut di BeritaHarian.sg`;
  const metaRobots =
    article.seoFields?.metaRobots && article.seoFields.metaRobots == 1
      ? "noindex, nofollow"
      : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

  const gaData = {
    title: article.title,
    level2: MATA_MATA_SECTION,
    chapter1: article.campaignReference?.title,
    contentcat: getContentCat(article.contentAccess),
    section: MATA_MATA_SECTION,
    contenttype: "1",
    pagination: pageNumber,
    author: getAuthorsName(article.authors || []),
    cue_articleid: article.id,
    articleid: article.id,
    keyword: keywords,
    pubdate: formatDate(article.datetime, "yyyy-MM-dd HH:mm:ss"),
    content_publication_date_utc: article.datetime,
    content_update_date_utc: article.dateEdited,
  } as GADataProps;

  const metaTags = {
    title: metaTitle,
    description: metaDescription,
    ogImage: ogImage,
    slug: article.urlPath,
    ogType: "Article",
    ogTitle: article.ogFields?.ogTitle || metaTitle,
    ogDescription: article.ogFields?.ogDescription || metaDescription,
    keywords: keywords.split(","),
    robotsContent: metaRobots,
    customCanonicalUrl: article.seoFields?.canonicalUrl,
    twitterCardContent: "summary",
    image: image,
    isArticlePage: true,
    publishedTime: formatDate(article.datetime, dateFormatWithTz),
    modifiedTime: formatDate(article.dateEdited, dateFormatWithTz),
    jsonLd: getArticleJSONLD(article),
    gsChannels,
  } as MetaTagsProps;

  return {
    gaData: gaData,
    metaTags: metaTags,
  };
}
